import { apiClient } from './client';

const multipartHeaders = { 'Content-Type': 'multipart/form-data' };

export const schoolApi = {
  getAll:  (params) => apiClient.get('/schools', { params }),
  getById: (id)     => apiClient.get(`/schools/${id}`),
  getActive: ()     => apiClient.get('/schools/active'),
  create: (data) => apiClient.post(
    '/schools', data,
    data instanceof FormData ? { headers: multipartHeaders } : {},
  ),
  update: (id, data) => apiClient.put(
    `/schools/${id}`, data,
    data instanceof FormData ? { headers: multipartHeaders } : {},
  ),
  delete: (id) => apiClient.delete(`/schools/${id}`),
};
